import { useState } from "react";
import { Dialog, DialogContent, IconButton, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MediaViewer = ({ multimediaLinks }: { multimediaLinks: string[] }) => {
  console.log({multimediaLinks})
  const [open, setOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState<string | null>(null);

  const handleOpen = (media: string) => {
    setSelectedMedia(media);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMedia(null);
  };

  return (
    <>
      <Grid container spacing={1} sx={{ mt: 1 }}>
        {multimediaLinks?.map((link, index) => {
          const isImage = link.match(/.(jpeg|jpg|gif|png)$/i);
          const isVideo = link.match(/.(mp4|webm|ogg)$/i);
          const isAudio = link.match(/.(mp3|wav|ogg)$/i);

          return (
            <Grid item key={index}>
              {isImage && (
                <img
                  src={link}
                  alt="Preview"
                  style={{ width: 50, height: 50, cursor: "pointer", borderRadius: 5 }}
                  onClick={() => handleOpen(link)}
                />
              )}
              {isVideo && (
                <video
                  width={50}
                  height={50}
                  style={{ cursor: "pointer", borderRadius: 5 }}
                  onClick={() => handleOpen(link)}
                >
                  <source src={link} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
              {isAudio && (
                <IconButton onClick={() => handleOpen(link)}>
                  🎵
                </IconButton>
              )}
            </Grid>
          );
        })}
      </Grid>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 0, top: 0 }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {selectedMedia && selectedMedia.match(/.(jpeg|jpg|gif|png)$/i) && (
            <img src={selectedMedia} alt="Preview" style={{ width: "100%" }} />
          )}
          {selectedMedia && selectedMedia.match(/.(mp4|webm|ogg)$/i) && (
            <video controls style={{ width: "100%" }}>
              <source src={selectedMedia} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {selectedMedia && selectedMedia.match(/.(mp3|wav|ogg)$/i) && (
            <audio controls style={{ width: "100%" }}>
              <source src={selectedMedia} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MediaViewer;
